import { render, staticRenderFns } from "./ProxyShareDialog.vue?vue&type=template&id=2702c000&scoped=true"
import script from "./ProxyShareDialog.vue?vue&type=script&lang=ts"
export * from "./ProxyShareDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2702c000",
  null
  
)

export default component.exports